module.exports = __webpack_public_path__ + "img/piliangqianshu.a0461275.png";